import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const zero = <span> 0,00 </span>
const MonetaryField = ({ source, record = {} }) =>
  <span>
    R$ {isNaN(_.get(record, source)) ? zero
    : (_.get(record, source))
    .toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 3})}
  </span>
MonetaryField.propTypes = {
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired
}

export default MonetaryField



// WEBPACK FOOTER //
// ./src/components/monetaryField.js